import React from 'react'
import { useTheme, styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { store } from 'reduxStore'

import { BusinessCreditScoreIcon } from 'assets'

const SIZES = {
  xlarge: 160,
  large: 140,
  normal: 120,
  small: 90,
  xsmall: 80,
}

const r = {
  xlarge: 16,
  large: 16,
  normal: 12,
  small: 6,
  xsmall: 6,
}

const POINTS = {
  xlarge: 453,
  large: 389,
  normal: 339,
  small: 264,
  xsmall: 199,
}

const BoxWrapper = styled(Box)(({ showPointer, size }) => ({
  cursor: showPointer ? 'pointer' : 'normal',
  width: size ? `${SIZES[size]}px` : '140px',
  height: size ? `${SIZES[size]}px` : '140px',
  position: 'relative',
}))

const InnerBox = styled(Box)(({ theme, size }) => ({
  border: '1px solid #F4F4F7',
  width: size ? `${SIZES[size] - 2 * r[size]}px` : '108px',
  height: size ? `${SIZES[size] - 2 * r[size]}px` : '108px',
  background: 'white',
  borderRadius: '50%',
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}))

const OuterBox = styled(Box)(({ theme, size }) => ({
  padding: `${r[size]}px`,
  width: size ? `${SIZES[size]}px` : '140px',
  height: size ? `${SIZES[size]}px` : '140px',
  background: '#F4F4F7',
  borderRadius: '50%',
  position: 'absolute',
  border: '1px solid #F4F4F7',
}))

const BusinessCreditProgressDisabled = props => {
  const theme = useTheme()
  const { title, size, ...rest } = props
  const user = store.getState().userReducer.user

  const showPointer = !!rest.onClick

  if (user.accountType === 'free') {
    return (
      <Box {...rest}>
        <BoxWrapper size={size}>
          <OuterBox size={size}>
            <InnerBox size={size}>
              <Box
                sx={{
                  display: 'inline-flex',
                  background: theme.palette.background.primary,
                  WebkitTextFillColor: 'transparent',
                  WebkitBackgroundClip: 'text',
                }}
              >
                <BusinessCreditScoreIcon />
              </Box>
            </InnerBox>
          </OuterBox>
          <svg
            width={size ? `${SIZES[size]}px` : '140px'}
            height={size ? `${SIZES[size]}px` : '140px'}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              transform: 'rotate(270deg)',
              cursor: showPointer ? 'pointer' : 'normal',
            }}
          >
            <defs>
              <linearGradient id="GradientColor" gradientTransform="rotate(90)">
                <stop offset="0%" stopColor="#0099FF" />
                <stop offset="100%" stopColor="#00CBA9" />
              </linearGradient>
            </defs>
            <circle
              cx={size ? `${SIZES[size] / 2}` : '70'}
              cy={size ? `${SIZES[size] / 2}` : '70'}
              r={size ? `${SIZES[size] / 2 - r[size] / 2}` : '62'}
              fill="none"
              strokeLinecap="normal"
              stroke="url(#GradientColor)"
              strokeWidth={`${r[size]}px`}
              strokeDasharray={180}
              strokeDashoffset={(size ? POINTS[size] : 389) - (props.value * (size ? POINTS[size] : 389)) / 100}
            />
          </svg>
        </BoxWrapper>
      </Box>
    )
  }

  return (
    <Box {...rest}>
      {title && (
        <Typography
          component={'span'}
          variant={'overline1'}
          color={'secondary'}
          sx={{
            width: '100%',
            textAlign: 'center',
            height: size === 'small' ? '20px' : '40px',
            display: 'inline-block',
            cursor: showPointer ? 'pointer' : 'normal',
          }}
        >
          {title}
        </Typography>
      )}
      <BoxWrapper size={size}>
        <OuterBox size={size}>
          <InnerBox size={size}>
            <Box
              sx={{
                display: 'inline-flex',
                background: '#BDBDCE',
                WebkitTextFillColor: 'transparent',
                WebkitBackgroundClip: 'text',
              }}
            >
              <Typography
                component="div"
                sx={{
                  lineHeight: '100%',
                  fontWeight: '600',
                  fontSize: size === 'small' ? '24px' : '36px',
                }}
              >
                {`${Math.round(props.value)}`} <br />
                <Typography
                  color={'#66668F'}
                  sx={{
                    fontSize: size === 'small' ? '14px' : '14px',
                    textAlign: 'center',
                  }}
                >
                  of 655
                </Typography>
              </Typography>
            </Box>
          </InnerBox>
        </OuterBox>
        <svg
          width={size ? `${SIZES[size]}px` : '140px'}
          height={size ? `${SIZES[size]}px` : '140px'}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            transform: 'rotate(270deg)',
            cursor: showPointer ? 'pointer' : 'normal',
          }}
        >
          <defs>
            <linearGradient id="GradientColor" gradientTransform="rotate(90)">
              <stop offset="0%" stopColor="#BDBDCE" />
              <stop offset="100%" stopColor="#BDBDCE" />
            </linearGradient>
          </defs>
          <circle
            cx={size ? `${SIZES[size] / 2}` : '70'}
            cy={size ? `${SIZES[size] / 2}` : '70'}
            r={size ? `${SIZES[size] / 2 - r[size] / 2}` : '62'}
            fill="none"
            strokeLinecap="normal"
            stroke="url(#GradientColor)"
            strokeWidth={`${r[size]}px`}
            strokeDasharray={size ? POINTS[size] : 389}
            strokeDashoffset={(size ? POINTS[size] : 389) - (props.value * (size ? POINTS[size] : 389)) / 650}
          />
        </svg>
      </BoxWrapper>
    </Box>
  )
}

export default BusinessCreditProgressDisabled
